module.exports = __webpack_public_path__ + "static/media/Logo-White.d3d07734.svg";